import { render, staticRenderFns } from "./replacementCodesTab.vue?vue&type=template&id=497225c9&scoped=true&"
import script from "./replacementCodesTab.vue?vue&type=script&lang=js&"
export * from "./replacementCodesTab.vue?vue&type=script&lang=js&"
import style0 from "./replacementCodesTab.vue?vue&type=style&index=0&id=497225c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497225c9",
  null
  
)

export default component.exports
import {QForm,QScrollArea,QInput} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QForm,QScrollArea,QInput})
